export default __webpack_public_path__ + "static/media/spongebob-music.6fe15f3e.gif";